export const ThrashIcon = () => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665'
            stroke='#D92D20'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M5.66797 3.31334L5.81464 2.44001C5.9213 1.80668 6.0013 1.33334 7.12797 1.33334H8.87464C10.0013 1.33334 10.088 1.83334 10.188 2.44668L10.3346 3.31334'
            stroke='#D92D20'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M12.5669 6.09332L12.1336 12.8067C12.0603 13.8533 12.0003 14.6667 10.1403 14.6667H5.86026C4.00026 14.6667 3.94026 13.8533 3.86693 12.8067L3.43359 6.09332'
            stroke='#D92D20'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M6.88672 11H9.10672'
            stroke='#D92D20'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M6.33203 8.33334H9.66536'
            stroke='#D92D20'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
